<form *ngIf="businessFormGroup" [formGroup]="businessFormGroup">
    <p-card class="p-3" header="Datos generales">
        
        <div class="grid"  >
            <div class="col-10 grid">
                <div class="col-6 input-field">
                    <label for="name">Nombre *</label>
                    <input pInputText formControlName="name" id="name" d-form-field-error />
                </div>
                <div class="col-6 input-field">
                    <label for="legalName">Nombre Legal *</label>
                    <input pInputText formControlName="legalName" id="legalName" d-form-field-error />
                </div>
                <div class="col-4 input-field ">
                    <label for="vatNumber">VAT</label>
                    <input pInputText id="vatNumber" formControlName="vatNumber" type="text" />
                </div>
                <div class="col-2 input-field">
                    <label for="active" class="mr-1">Activo</label>
                    <div class="flex h-full">
                        <p-inputSwitch id="active" formControlName="active"></p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class=" col-2 grid">
                <div class="" *ngIf="business.logoId" style="position: relative;">
                    <div style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                        <img [src]="imagesUrl + business.logoId + '/download'" alt="Logo" class="w-full" />
                    </div>
                    <p-button (click)="deleteLogo()" [rounded]="true" [style]="{ position: 'absolute', top: '0', right: '0' }"
                            [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                </div>    
                <div class="col-12" *ngIf="!business.logoId">
                    <p-fileUpload mode="basic" chooseIcon="pi pi-upload"
                        chooseLabel="Seleccionar logo" (onSelect)="onFileSelect($event)" />
                </div>
            </div>
        </div>
        <div class="grid pt-2">
            <div class="col-4 input-field ">
                <label for="phone1">Teléfono 1</label>
                <input pInputText id="phone1" formControlName="phone1" type="text" />
            </div>
            <div class="col-4 input-field ">
                <label for="phone2">Teléfono 2</label>
                <input pInputText id="phone2" formControlName="phone2" type="text" />
            </div>
            <div class="col-4 input-field ">
                <label for="email">Email</label>
                <input pInputText id="email" formControlName="email" type="text" />
            </div>
        </div>
        <div class="grid pt-2" formGroupName="address">
            <div class="col input-field">
                <label for="addressLine1">Dirección *</label>
                <input pInputText formControlName="addressLine1" type="text" d-form-field-error />
            </div>
            <div class="col input-field">
                <label for="zipCode">Código postal</label>
                <input pInputText formControlName="zipCode" type="text" d-form-field-error />
            </div>
            <div class="col input-field">
                <label for="city">Ciudad</label>
                <input pInputText formControlName="city" type="text" d-form-field-error />
            </div>
            <div class="col input-field">
                <label for="name">Provincia</label>
                <p-dropdown [options]="countriesRegions" formControlName="countryRegionId" optionValue="id"
                    [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione provincia"
                    d-form-field-error showClear (onChange)="loadCountries()" />
            </div>
            <div class="col input-field">
                <label for="countryCode">País</label>
                <p-dropdown [options]="countries" formControlName="countryCode" [required]="true" optionValue="code"
                    [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione país" />
            </div>
        </div>
        <div class="grid pt-2">
            <div class="col input-field">
                <label for="commercialRegister">Registro mercantil *</label>
                <input pInputText formControlName="commercialRegister" type="text" d-form-field-error />
            </div>
        </div>

        <div class="grid pt-2">
            <div class="col flex align-items-center">     
                <p-fileUpload mode="basic" accept=".doc,.docx,.pdf" chooseIcon="pi pi-upload" (onSelect)="onCertificateFile($event)" [multiple]="false"  chooseLabel="Seleccionar certificado" />
                <p-button *ngIf="business.certificateFileId != null"  [link]="true"  (onClick)="downloadFile(business.certificateFileId)" > {{business.certificateFile.fileName}}&nbsp;<i class="pi pi-download"></i></p-button>
                
                    <p-button (click)="deleteCertificate()" [rounded]="true"  *ngIf="business.certificateFileId != null"  [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
            </div>
            <div class="col input-field">
                <label for="certificateFilePassword">Contraseña del certificado</label>                    
                 <p-password placeholder="Contraseña"  [feedback]="false" [toggleMask]="true" formControlName="certificateFilePassword"  />
            </div>
        </div>
        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete && business.id" icon="pi pi-trash"
                styleClass="p-button-danger" (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>

    <p-tabView *ngIf="business.id">
        <p-tabPanel header="Cuentas Bancarias">
            <div class="flex justify-content-end">
                <p-button label="Añadir cuenta bancaria" *ngIf="allowWrite" icon="pi pi-plus" styleClass=""
                    (click)="editBankAccount(null)"></p-button>
            </div>

            <p-table styleClass="m-1 mt-4" #grid [value]="businessBankAccounts" [loading]="loading" [paginator]="true"
                [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[5,10,25,50]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="bankId">Banco <p-sortIcon field="bankId" /></th>
                        <th pSortableColumn="accountNumber">IBAN <p-sortIcon field="accountNumber" /></th>
                        <th pSortableColumn="swift">Swift <p-sortIcon field="swift" /></th>
                        <th [width]="150"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-businessBankAccount let-columns="columns">
                    <tr (dblclick)="editBankAccount(businessBankAccount)">
                        <td>{{businessBankAccount.bank.name}}</td>
                        <td>{{businessBankAccount.accountNumber | uppercase}}</td>
                        <td>{{businessBankAccount.swift}}</td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteBankAccount(businessBankAccount)"
                                    [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="editBankAccount(businessBankAccount)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</form>
<p-confirmDialog></p-confirmDialog>